<!-- For ports AMS or RTM -->
@if (context.visit.orderIncomingMovement) {
  @if (context.visit.visitDeclaration.portVisit.portEntry; as portEntry) {
    <div class="fieldset"
         [ngClass]="{'disabled' : context.visitIsDeparted()}">
      <app-port-entry [portEntry]="portEntry"
                      [firstBerthVisit]="context.visit.visitDeclaration.portVisit.berthVisits[0]"
                      [pilotStation]="context.visit.visitDeclaration.portVisit.pilotStation"
                      [pilotOnBoard]="getPilotOnBoardArrival"
                      [entryDependency]="portEntry.origin === 'SEA' ? portEntry.entryDependency : null">
      </app-port-entry>
    </div>
  } @else {
    <!-- Visit created without a port entry: let the user choose one (like the create-visit screen).
         As soon as a choice resolves a port entry, the regular port-entry form above takes over. -->
    <div class="fieldset"
         [ngClass]="{'disabled' : context.visitIsDeparted()}">
      <app-port-entry-create></app-port-entry-create>
    </div>
  }
}

<!-- For ports other than AMS or RTM -->
@if (!context.visit.orderIncomingMovement) {
  <div class="row">
    <div class="col-md-6">
      <app-eta-eu-entry [(etaFirstEntryEu)]="context.visit.visitDeclaration.etaFirstEntryEu"></app-eta-eu-entry>
      <app-entry-point></app-entry-point>
    </div>
    <div class="col-md-6">
      <app-arrival-voyage [voyage]="context.visit.visitDeclaration.arrivalVoyage"></app-arrival-voyage>
    </div>
  </div>
  <!-- Nautical services -->
  @if (context.visit.orderNauticalServices) {
    <div class="row">
      <div class="col-md-6">
        <app-pilot-station></app-pilot-station>
      </div>
    </div>
  }
}




